import { render, staticRenderFns } from "./BaseSearchModal.vue?vue&type=template&id=459d4452&"
import script from "./BaseSearchModal.vue?vue&type=script&lang=js&"
export * from "./BaseSearchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports